<template>
  <div class="monitorPage">
    <div class="leftContent">
      <Tabs v-model="activeTab" class="searchTab" @change="getList">
        <TabPane :key="1" tab="识别订单">
          <FormModel>
            <Row :gutter="24">
              <Col :span="6">
                <FormModelItem>
                  <Select placeholder="请选择影像中心" :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" allowClear v-model.trim="monitorSearchPanel.centerId">
                    <Option v-for="val in searchHospitalList" :key="val.id" :value="val.id">{{ val.name }}</Option>
                  </Select>
                </FormModelItem>
              </Col>
              <Col :span="6">
                <FormModelItem>
                  <DateRangePicker style="width: 100%" v-model.trim="monitorSearchPanel.startAEndTime" :placeholder="['开始时间', '结束时间']"/>
                </FormModelItem>
              </Col>
              <Col :span="6">
                <FormModelItem>
                  <Select placeholder="请选择匹配状态" :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="monitorSearchPanel.comparisonResults">
                    <Option :value="-2">全部</Option>
                    <Option :value="0">未匹配</Option>
                    <Option :value="-1">匹配失败</Option>
                    <Option :value="1">匹配成功</Option>
                  </Select>
                </FormModelItem>
              </Col>
              <Col :span="6">
                <FormModelItem>
                  <Button type="primary" @click="getList(1)" :loading="monitorSearchPanel.tableLoading" :disabled="monitorSearchPanel.tableLoading">查询</Button>
                </FormModelItem>
              </Col>
            </Row>
          </FormModel>
          <div class="divider"></div>
          <div class="orderListWrap">
            <Table :loading="monitorSearchPanel.tableLoading" :customRow="customRow" :dataSource="monitorSearchPanel.orderList" :rowClassName="(record) => { return (orderDetail.orderCode == record.orderCode && activeTab === 1) ? 'clickRowStyle' : '' } " :pagination='false' rowKey="id" :columns="monitorSearchPanel.columns" style="width: 100%;">
              <template slot="monitorCenterName" slot-scope="item">{{ getMonitorCenterName(item.deviceInfoCode) }}</template>
              <template slot="checkDate" slot-scope="item"> 
                <span v-if="item.checkDate">{{ formateDate (item.checkDate, 'YYYY-MM-DD') }}</span>
              </template>
              <template slot="startTime" slot-scope="item"> 
                <span v-if="item.startTime">{{ formateDate (item.startTime, 'HH:mm') }}</span>
              </template>
              <template slot="endTime" slot-scope="item"> 
                <span v-if="item.endTime">{{ formateDate (item.endTime, 'HH:mm') }}</span>
              </template>
              <template slot="comparisonResults" slot-scope="item"> 
                <span v-if="item.comparisonResults === -1" style="color:red;">匹配失败</span>
                <span v-else-if="item.comparisonResults === 0">未匹配</span>
                <span v-else-if="item.comparisonResults === 1">匹配成功</span>
              </template>
              <template slot="operation" slot-scope="item">
                <div v-if="item.comparisonResults !== 1">
                  <Button size="small"  @click.stop="matchOrder(item)">匹配订单</Button>
                  <Button size="small" style="margin-left: 10px;" @click.stop="addRemarkInfo(item)">备注</Button>
                </div>
              </template>
            </Table>
          </div>
          <div class="page">
            <Pagination v-model="monitorSearchPanel.pageNumber" :pageSize.sync="monitorSearchPanel.pageSize" :total="monitorSearchPanel.totalRecord" @change="getList" />
          </div>
        </TabPane>
        <TabPane :key="2" tab="RIS订单">
          <FormModel>
            <Row :gutter="24">
              <Col :span="4">
                <FormModelItem>
                  <Select placeholder="请选择影像中心" :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" allowClear v-model.trim="risSearchPanel.centerId">
                    <Option v-for="val in searchHospitalList" :key="val.id" :value="val.id">{{ val.name }}</Option>
                  </Select>
                </FormModelItem>
              </Col>
              <Col :span="6">
                <FormModelItem>
                  <DateRangePicker style="width: 100%" v-model.trim="risSearchPanel.startAEndTime" :placeholder="['开始时间', '结束时间']"/>
                </FormModelItem>
              </Col>
              <Col :span="4">
                <FormModelItem>
                  <Select placeholder="请选择匹配状态" :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="risSearchPanel.comparisonResults">
                    <Option :value="-2">全部</Option>
                    <Option :value="0">未匹配</Option>
                    <Option :value="-1">匹配失败</Option>
                    <Option :value="1">匹配成功</Option>
                  </Select>
                </FormModelItem>
              </Col>
              <Col :span="5">
                <FormModelItem>
                  <Input placeholder="请输入检查单号" v-model.trim="risSearchPanel.orderCode" allowClear/>
                </FormModelItem>
              </Col>
              <Col :span="4">
                <FormModelItem>
                  <Button type="primary" @click="getList(1)" :loading="risSearchPanel.tableLoading" :disabled="risSearchPanel.tableLoading">查询</Button>
                </FormModelItem>
              </Col>
            </Row>
          </FormModel>
          <div class="divider"></div>
          <div class="orderListWrap">
            <Table :loading="risSearchPanel.tableLoading" :customRow="customRow" :dataSource="risSearchPanel.orderList" :rowClassName="(record) => { return (orderDetail.orderCode == record.orderCode && activeTab === 2) ? 'clickRowStyle' : '' } " :pagination='false' rowKey="id" :columns="risSearchPanel.columns" style="width: 100%;">
              <template slot="checkDate" slot-scope="item"> 
                <span>{{ formateDate (item.serviceOperationDatetime, 'YYYY-MM-DD') }}</span>
              </template>
              <template slot="comparisonResults" slot-scope="item"> 
                <span v-if="item.comparisonResults === -1" style="color:red;">匹配失败</span>
                <span v-else-if="item.comparisonResults === 0">未匹配</span>
                <span v-else-if="item.comparisonResults === 1">匹配成功</span>
              </template>
            </Table>
          </div>
          <div class="page">
            <Pagination v-model="risSearchPanel.pageNumber" :pageSize.sync="risSearchPanel.pageSize" :total="risSearchPanel.totalRecord" @change="getList" />
          </div>
        </TabPane>
      </Tabs>
    </div>
    <div class="rightContent">
      <div class="rightContentWrap">
        <div class="cellItem">
          <div class="label">医院名称</div>
          <div class="labelVal">{{ orderDetail.monitorCenterName || orderDetail.hospitalMedicalImageCenterName }}</div>
        </div>
        <div class="cellItem">
          <div class="label">检查单号</div>
          <div class="labelVal">{{ orderDetail.orderCode }}</div>
        </div>
        <div class="cellItem">
          <div class="label">检查日期</div>
          <div class="labelVal">{{ formateDate(orderDetail.checkDate, 'YYYY-MM-DD') }}</div>
        </div>
        <div class="cellItem">
          <div class="label">开始时间</div>
          <div class="labelVal">{{ formateDate(orderDetail.startTime, 'HH:mm') }}</div>
        </div>
        <div class="cellItem">
          <div class="label">完成时间</div>
          <div class="labelVal">{{ formateDate(orderDetail.endTime, 'HH:mm') }}</div>
        </div>
        <div class="cellItem" v-if="activeTab === 1">
          <div class="label">患者姓名拼音</div>
          <div class="labelVal">{{ orderDetail.patientName }}</div>
        </div>
        <div class="cellItem" v-if="activeTab === 2">
          <div class="label">患者姓名</div>
          <div class="labelVal">{{ orderDetail.patientName }}</div>
        </div>
        <div class="cellItem">
          <div class="label">设备编码</div>
          <div class="labelVal">{{ orderDetail.deviceInfoCode }}</div>
        </div>
        <div class="cellItem">
          <div class="label">设备类型</div>
          <div class="labelVal">{{ orderDetail.deviceType }}</div>
        </div>
        <div class="cellItem" v-if="activeTab === 1">
          <div class="label">检查图片</div>
          <div class="labelVal">
            <viewer :images="orderDetail.imageList">
              <img class="imageItem" v-for="(imgUrl, imgIndex) in orderDetail.imageList || []" :key="imgIndex" :src="imgUrl" alt="" srcset="">
            </viewer>
          </div>
        </div>
        <div class="cellItem" v-if="activeTab === 1">
          <div class="label">检查视频</div>
          <div class="labelVal">
            <span class="videoUrl" v-for="(video, vIndex) in orderDetail.videoList || []" :key="vIndex" @click="watchVideo(video)">{{ getVideoName(video) }}</span>
          </div>
        </div>
        <div class="cellItem" v-if="activeTab === 2">
          <div class="label">检查部位</div>
          <div class="labelVal">
            <span style="display:block;padding: 0 0 5px 0;" v-for="(bodyName, nameIndex) in (orderDetail.bodyItem ? orderDetail.bodyItem.split(',') : [])" :key="nameIndex">{{ bodyName }}</span>
          </div>
        </div>
        <div v-if="activeTab === 1">
          <div style="font-size: 16px;">备注信息：</div>
          <div style="border: 1px solid #eee; margin-top: 10px; padding: 10px;">{{ decodeURIComponent(orderDetail.remark) }}</div>

          <div style="margin-top: 12px;" v-if="orderDetail.remarkImg">
            <viewer :images="orderDetail.remarkImg ? orderDetail.remarkImg.split(',') : []">
              <img class="imageItem" style="margin-right: 12px; margin-bottom: 12px; width: 100px; object-fit: cover; cursor: pointer;" v-for="(imgUrl, imgIndex) in orderDetail.remarkImg.split(',') || []" :key="imgIndex" :src="imgUrl" alt="" srcset="">
            </viewer>
          </div>
        </div>
      </div>
    </div>
    <!-- 匹配订单 -->
    <Modal class="mateModal" title="匹配订单" :pagination='false' :visible="mateModal.visible" @cancel="closeMateModal" @ok="matchOrderAction" ok-text="匹配订单" :confirm-loading="mateModal.confirmLoading" :width="1200">
      <div class="mateModalContent">
        <div class="leftContent">
          <div class="modalSearch">
            <Row :gutter="24">
              <Col :span="4">
                <Input  placeholder="订单号" allowClear v-model.trim="mateModal.orderCode"/>
              </Col>
              <Col :span="4">
                <Input placeholder="姓名拼音" allowClear v-model.trim="mateModal.patientNamePinyin"/>
              </Col>
              <Col :span="4">
                <Input placeholder="患者年龄" allowClear type="number" v-model.trim="mateModal.age"/>
              </Col>
              <Col :span="7">
                <DateRangePicker style="width: 100%" v-model.trim="mateModal.startAEndTime" :placeholder="['开始时间', '结束时间']"/>
              </Col>
              <Col :span="4">
                <Button type="primary" @click="getMatchOrderList" :loading="mateModal.tableLoading" :disabled="mateModal.tableLoading">搜索</Button>
              </Col>
            </Row>
          </div>
          <div class="orderList">
            <Table :row-selection="mateModal.rowSelection" :dataSource="mateModal.orderList" :loading="mateModal.tableLoading" :pagination='false' :columns="mateModal.columns" >
              <template slot="appointmentTime" slot-scope="item"> 
                <span>{{ formateDate (item.serviceAppointmentDatetime, 'HH:mm') }}</span>
              </template>
              <template slot="serviceFinishAt" slot-scope="item"> 
                <span>{{ formateDate (item.serviceFinishAt, 'HH:mm') }}</span>
              </template>
              <template slot="checkDate" slot-scope="item"> 
                <span>{{ formateDate (item.serviceOperationDatetime, 'YYYY-MM-DD') }}</span>
              </template>
              <template slot="bodyItem" slot-scope="item">
                <span style="margin-right: 10px;" v-for="(bodyName, nameIndex) in (item.bodyItem ? item.bodyItem.split(',') : [])" :key="nameIndex">{{ bodyName }}</span>
              </template>
            </Table>
          </div>
        </div>
        <div class="rightContent">
          <div class="cellItem">
            <div class="label">医院名称</div>
            <div class="labelVal">{{ mateModal.needMatchOrder.monitorCenterName }}</div>
          </div>
          <div class="cellItem">
            <div class="label">检查单号</div>
            <div class="labelVal">{{ mateModal.needMatchOrder.orderCode }}</div>
          </div>
          <div class="cellItem">
            <div class="label">检查日期</div>
            <div class="labelVal">{{ formateDate(mateModal.needMatchOrder.checkDate, 'YYYY-MM-DD')}}</div>
          </div>
          <div class="cellItem">
            <div class="label">开始时间</div>
            <div class="labelVal">{{ formateDate(mateModal.needMatchOrder.startTime, 'HH:mm')}}</div>
          </div>
          <div class="cellItem">
            <div class="label">完成时间</div>
            <div class="labelVal">{{ formateDate(mateModal.needMatchOrder.endTime, 'HH:mm')}}</div>
          </div>
          <div class="cellItem">
            <div class="label">患者姓名拼音</div>
            <div class="labelVal">{{ mateModal.needMatchOrder.patientName }}</div>
          </div>
          <div class="cellItem">
            <div class="label">设备编码</div>
            <div class="labelVal">{{ mateModal.needMatchOrder.deviceInfoCode }}</div>
          </div>
          <div class="cellItem">
            <div class="label">设备类型</div>
            <div class="labelVal">{{ mateModal.needMatchOrder.deviceType }}</div>
          </div>
          <div class="cellItem">
            <div class="label">检查图片</div>
            <div class="labelVal">
              <viewer :images="orderDetail.imageList">
                <img class="imageItem" v-for="(imgUrl, imgIndex) in mateModal.needMatchOrder.imageList || []" :key="imgIndex" :src="imgUrl" alt="" srcset="">
              </viewer>
            </div>
          </div>
        </div>
      </div>
    </Modal>
    <!-- 视频查看 -->
    <Modal class="showVideoModal" v-if="showVideoModal.visible" :title="showVideoModal.title" :visible="showVideoModal.visible" :footer="null" :width="960" @cancel="closeVideoModal">
      <videoPlayer ref="videoPlayer" :playsinline="true" :options="showVideoModal.playerOptions"/>
    </Modal>
    <!-- 上传备注信息 -->
    <Modal class="showRemarkModal" title="备注" :visible="showRemarkModal.visible" :width="960" @cancel="closeShowRemarkModal" @ok="addRemarkAction" :confirmLoading="showRemarkModal.saveLoading">
      <div>
        <div>
          <p>备注信息</p>
          <Input type="textarea" allowClear placeholder="请输入备注信息" rows="5" v-model="showRemarkModal.remark"/>
        </div>
        <div class="uploadPanel">
          <Upload :showUploadList="false" :beforeUpload="(file) => { addImageBefore(file); return false;}">
            <Button type="primary" :disabled="showRemarkModal.uploading" :loading="showRemarkModal.uploading">
              <Icon type="upload" v-if="!showRemarkModal.uploading"/>
              <span>{{ showRemarkModal.uploading ? '上传中' : '点击上传图片' }}</span>
            </Button>
          </Upload>
          <div class="imageList">
            <div class="imageItem" v-for="(item, index) in showRemarkModal.fileList" :key="index" style="">
              <img :src="item"/>
              <div class="actionWrap">
                <div @click="previewImage(item)" style="margin-right: 10px;"><Icon type="eye" style="font-size:16px;cursor:pointer;"></Icon></div>
                <div @click="deleteImage(index)"><Icon type="delete" style="font-size:16px;cursor:pointer;"></Icon></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
    <Modal title="图片预览" :width="800"  :footer="null" v-model="showRemarkModal.imagePreview">
      <img v-if='showRemarkModal.previewUrl' :src="showRemarkModal.previewUrl" style="width:100%;"/>
    </Modal>
  </div>
</template>
<script>
import { Tabs, FormModel, Row, Col, Select, DatePicker, Button, Table, Modal, Input, Pagination, Upload, Icon } from 'ant-design-vue'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
import { getParamFromRoute, getSession, setCurrentUrl, toast, getFileSuffix } from '../../libs/utils'
import moment from 'moment'
import { getMonitorData, uploadAbnormalImg } from '../../api/onlineOperation'
export default {
  components: {
    Icon,
    Tabs,
    Pagination,
    Input,
    Row,
    Table,
    Modal,
    Select,
    Option: Select.Option,
    Col,
    DateRangePicker: DatePicker.RangePicker,
    Button,
    TabPane: Tabs.TabPane,
    FormModel,
    FormModelItem: FormModel.Item,
    videoPlayer,
    Upload
  },
  data () {
    const userAuth = getSession('userAuth', 'object') || {}
    return {
      activeTab: 1,
      searchHospitalList: userAuth.centerVos || [],
      monitorSearchPanel: {
        startAEndTime: [],
        tableLoading: false,
        orderList: [],
        pageNumber: 1,
        pageSize: 10,
        totalRecord: 0,
        centerId: undefined,
        comparisonResults: -2,
        columns: [
          {
            title: '识别单号',
            dataIndex: 'orderCode',
            width: 110
          },
          {
            title: '影像中心',
            scopedSlots: { customRender: 'monitorCenterName' },
            width: 100
          },
          {
            title: '患者姓名',
            dataIndex: 'patientName',
            width: 100
          },
          {
            title: '年龄',
            dataIndex: 'age',
            width: 30
          },
          {
            title: '检查日期',
            scopedSlots: { customRender: 'checkDate' },
            width: 70
          },
          {
            title: '开始时间',
            scopedSlots: { customRender: 'startTime' },
            width: 60
          },
          {
            title: '完成时间',
            scopedSlots: { customRender: 'endTime' },
            width: 60
          },
          {
            title: '匹配状态',
            scopedSlots: { customRender: 'comparisonResults' },
            width: 50
          },
          {
            title: '操作',
            scopedSlots: { customRender: 'operation' },
            width: 128
          }
        ]
      },
      orderDetail: {},
      risSearchPanel: {
        startAEndTime: [],
        tableLoading: false,
        record: '',
        orderList: [],
        pageNumber: 1,
        pageSize: 10,
        totalRecord: 0,
        centerId: undefined,
        comparisonResults: -2,
        columns: [
          {
            title: '检查单号',
            dataIndex: 'orderCode',
            width: 110
          },
          {
            title: '影像中心',
            dataIndex: 'hospitalMedicalImageCenterName',
            width: 100
          },
          {
            title: '患者姓名',
            dataIndex: 'patientName',
            width: 100
          },
          {
            title: '年龄',
            dataIndex: 'age',
            width: 50
          },
          {
            title: '检查日期',
            scopedSlots: { customRender: 'checkDate' },
            width: 90
          },
          {
            title: '匹配状态',
            scopedSlots: { customRender: 'comparisonResults' },
            width: 90
          }
        ]
      },
      mateModal:{
        visible: false,
        columns: [
          {
            title: '订单编号',
            dataIndex: 'orderCode',
            width: 110
          },
          {
            title: '检查日期',
            scopedSlots: { customRender: 'checkDate' },
            width: 120
          },
          {
            title: '预约时间',
            scopedSlots: { customRender: 'appointmentTime' },
            width: 90
          },
          {
            title: '完成时间',
            scopedSlots: { customRender: 'serviceFinishAt' },
            width: 90
          },
          {
            title: '患者姓名',
            dataIndex: 'patientName',
            width: 90
          },
          {
            title: '姓名拼音',
            key: 'patientNamePinyin',
            dataIndex: 'patientNamePinyin',
            width: 90
          },
          {
            title: '年龄',
            key: 'age',
            dataIndex: 'age',
            width: 60
          },
          {
            title: '检查部位',
            scopedSlots: { customRender: 'bodyItem' }
          }
        ],
        selectRow: null,
        rowSelection: {
          type: 'radio',
          onSelect: (record) => {
            this.mateModal.selectRow = record
          }
        },
        tableLoading: false,
        confirmLoading: false,
        pageSize: 10,
        pageNumber: 1,
        orderCode: '',
        patientNamePinyin: '',
        age: '',
        startAEndTime: [],
        orderList: [],
        needMatchOrder: {}
      },
      showVideoModal: {
        visible: false,
        title: '视频展示',
        playerOptions: {
          height: '500',
          autoplay: true,
          muted: false,
          language: 'zh-CN',
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: []
        }
      },
      showRemarkModal: {
        visible: false,
        fileList: [],
        remark: '',
        orderCode: '',
        uploading: false,
        previewUrl: '',
        imagePreview: false,
        saveLoading: false
      }
    }
  },
  async mounted () {
    const routerParams = getParamFromRoute(this.$route)
    if (routerParams.activeTab == 1) {
      this.activeTab = 1
      if (routerParams.startDate) this.monitorSearchPanel.startAEndTime[0] = moment(routerParams.startDate)
      if (routerParams.endDate) this.monitorSearchPanel.startAEndTime[1] = moment(routerParams.endDate)
      if (routerParams.comparisonResults) this.monitorSearchPanel.comparisonResults = 1 * routerParams.comparisonResults
      if (routerParams.centerId) this.monitorSearchPanel.imageCenterId = routerParams.centerId
      if (routerParams.pageNumber) this.monitorSearchPanel.pageNumber = 1 * routerParams.pageNumber
    } else if (routerParams.activeTab == 2) {
      this.activeTab = 2
      if (routerParams.startDate) this.risSearchPanel.startAEndTime[0] = moment(routerParams.startDate)
      if (routerParams.endDate) this.risSearchPanel.startAEndTime[1] = moment(routerParams.endDate)
      if (routerParams.comparisonResults) this.risSearchPanel.comparisonResults = 1 * routerParams.comparisonResults
      if (routerParams.imageCenterId) this.risSearchPanel.centerId = 1 * routerParams.imageCenterId
      if (routerParams.pageNumber) this.risSearchPanel.pageNumber = 1 * routerParams.pageNumber
    }
    await this.getList()
  },
  methods: {
    async requestMonitorData (params) {
      const data = await getMonitorData(params)
      const jsonData = JSON.parse(data)
      if (!jsonData) throw('获取监控数据列表异常')
      else if (jsonData.code !== 200) throw(jsonData.msg)
      return jsonData
    },
    async getList (page) {
      const params = {}
      const paramsContent = {}
      if (this.activeTab === 1) {
        if (page) this.monitorSearchPanel.pageNumber = page
        params.method = 'monitorService.deviceMonitoredInfoIPage'
        paramsContent.pageNumber = this.monitorSearchPanel.pageNumber
        paramsContent.pageSize = this.monitorSearchPanel.pageSize
        if (this.monitorSearchPanel.centerId) paramsContent.centerId = this.monitorSearchPanel.centerId
        if (this.monitorSearchPanel.startAEndTime.length > 0) {
          paramsContent.startDate = this.monitorSearchPanel.startAEndTime[0].format('YYYY-MM-DD')
          paramsContent.endDate = this.monitorSearchPanel.startAEndTime[1].format('YYYY-MM-DD')
        }
        if (this.monitorSearchPanel.comparisonResults !== -2) paramsContent.comparisonResults = this.monitorSearchPanel.comparisonResults
        this.monitorSearchPanel.tableLoading = true
      } else if (this.activeTab === 2) {
        if (page) this.risSearchPanel.pageNumber = page
        params.method = 'monitorService.realCheckOrderInfoIPage'
        paramsContent.pageNumber = this.risSearchPanel.pageNumber
        paramsContent.pageSize = this.risSearchPanel.pageSize
        if (this.risSearchPanel.centerId) paramsContent.imageCenterId = this.risSearchPanel.centerId
        if (this.risSearchPanel.orderCode) paramsContent.orderCode = this.risSearchPanel.orderCode
        if (this.risSearchPanel.startAEndTime.length > 0) {
          paramsContent.startDate = this.risSearchPanel.startAEndTime[0].format('YYYY-MM-DD')
          paramsContent.endDate = this.risSearchPanel.startAEndTime[1].format('YYYY-MM-DD')
        }
        if (this.risSearchPanel.comparisonResults !== -2) paramsContent.comparisonResults = this.risSearchPanel.comparisonResults
        this.risSearchPanel.tableLoading = true
      }
      setCurrentUrl(Object.assign({ activeTab: this.activeTab }, paramsContent))
      params.content = paramsContent
      try {
        const jsonData = await this.requestMonitorData(params)
        if (this.activeTab === 1) {
          this.monitorSearchPanel.totalRecord = jsonData.data.total
          this.monitorSearchPanel.orderList = jsonData.data.records || []
          this.selectItem(jsonData.data.records[0])
        } else if (this.activeTab === 2) {
          this.risSearchPanel.totalRecord = jsonData.data.total
          this.risSearchPanel.orderList = jsonData.data.records || []
          this.selectItem(jsonData.data.records[0])
        }
      } catch (error) {
       toast({ msg: error.message })
      } finally {
        if (this.activeTab === 1) {
          this.monitorSearchPanel.tableLoading = false
        } else if (this.activeTab === 2) {
          this.risSearchPanel.tableLoading = false
        }
      }
    },
    formateDate (value, type) {
      if (!value) return ''
      return moment(value).format(type)
    },
    customRow (record, index) {
      return {
        on: {
          click: () => {
            this.selectItem(record, index)
          }
        }
      }
    },
    getMonitorCenterName (code) {
      const centerList = this.searchHospitalList
      for(let i = 0; i < centerList.length; i++) {
        if (code.indexOf(`RIS_${centerList[i].id}`) !== -1) return centerList[i].name
      }
    },
    async selectItem (record) {
      if (this.activeTab === 1) {
        await this.getOrderDetail(record)
      } else if (this.activeTab === 2) {
        this.orderDetail = record || {}
      }
    },
    async requestOrderDetail (record) {
      const params = {
        method: 'monitorService.getDeviceMonitoredInfoDetail',
        content: { id: record.id }
      }
      try {
        const data = await getMonitorData(params)
        const jsonData = JSON.parse(data)
        if (!jsonData) throw('获取监控数据列表异常')
        else if (jsonData.code !== 200) throw(jsonData.msg)
        return jsonData.data
      } catch (error) {
        toast({ msg: error.message })
      }
    },
    async getOrderDetail (record) {
      const data = await this.requestOrderDetail(record)
      if (data) this.orderDetail = data
    },
    getVideoName (url) {
      const index = url.lastIndexOf('?')
      if (index !== -1) {
        url = url.substring(0, index)
      }
      const tempArr = url.split('/')
      return tempArr[tempArr.length - 1]
    },
    watchVideo (videoUrl) {
      this.showVideoModal.playerOptions.sources = [
        {
          type: 'video/mp4',
          src: videoUrl
        }
      ]
      this.showVideoModal.visible = true
    },
    closeVideoModal () {
      this.showVideoModal.visible = false
      this.showVideoModal.playerOptions.sources = []
    },
    async getMatchOrderList () {
      const params = {
        method: 'monitorService.realCheckOrderInfoIPage',
        content: {
          pageNumber: 1,
          pageSize: 100,
          imageCenterId: this.mateModal.needMatchOrder.monitorSourceCenterId,
          deviceType: this.mateModal.needMatchOrder.deviceType,
          comparisonResults: -1
        }
      }
      if (this.mateModal.startAEndTime.length >= 1) {
        params.content.startDate = moment(this.mateModal.startAEndTime[0]).format('YYYY-MM-DD')
        params.content.endDate = moment(this.mateModal.startAEndTime[1]).add(1, 'd').format('YYYY-MM-DD')
      } else {
        params.content.startDate = moment(this.mateModal.needMatchOrder.createdDate).add(-1, 'd').format('YYYY-MM-DD')
        params.content.endDate = moment(this.mateModal.needMatchOrder.createdDate).add(1, 'd').format('YYYY-MM-DD')
      }
      try {
        this.mateModal.tableLoading = true
        if (this.mateModal.age) params.content.age = this.mateModal.age
        if (this.mateModal.patientNamePinyin) params.content.patientNamePinyin = this.mateModal.patientNamePinyin
        if (this.mateModal.orderCode) params.content.orderCode = this.mateModal.orderCode
        const data = await this.requestMonitorData(params)
        this.mateModal.orderList = data.data.records || []
      } catch (error) {
        toast({ msg: error })
      } finally {
        this.mateModal.tableLoading = false
      }
    },
    async matchOrder (order) {
      this.mateModal.visible = true
      this.mateModal.startAEndTime = [moment(this.mateModal.needMatchOrder.createdDate).add(-1, 'd'), moment(this.mateModal.needMatchOrder.createdDate).add(1, 'd')]
      const data = await this.requestOrderDetail(order)
      if (data) {
        this.mateModal.needMatchOrder = Object.assign({}, order, data)
        await this.getMatchOrderList()
      }
    },
    closeMateModal () {
      this.mateModal.visible = false
      this.mateModal.needMatchOrder = {}
      this.mateModal.orderList = []
      this.mateModal.startAEndTime = []
      this.mateModal.orderCode = ''
      this.mateModal.age = ''
      this.mateModal.patientNamePinyin = ''
      this.mateModal.selectRow = null
    },
    async matchOrderAction () {
      if (!this.mateModal.selectRow) return toast({ msg: '请先选择匹配的订单' })
      try {
        const params = {
          method: 'monitorService.match',
          content: {
            monitoredId: this.mateModal.needMatchOrder.id,
            checkOrderId: this.mateModal.selectRow.id,
            isBind: true
          }
        }
        this.mateModal.confirmLoading = true
        const data = await getMonitorData(params)
        const jsonData = JSON.parse(data)
        if (!jsonData) throw('绑定异常')
        else if (jsonData.code !== 200) throw(jsonData.message)
        toast({ msg: '匹配成功', title: '操作提示', type: 'success' })
        this.closeMateModal()
        await this.getList()
      } catch (error) {
        toast({ msg: error })
      } finally {
        this.mateModal.confirmLoading = false
      }
    },
    addRemarkInfo (item) {
      this.showRemarkModal.record = item
      this.showRemarkModal.remark = item.remark || ''
      if (item.remarkImg) {
        this.showRemarkModal.fileList = item.remarkImg.split(',')
      }
      this.showRemarkModal.visible = true
    },
    async addImageBefore (file) {
      let fileType = getFileSuffix(file.name)
      fileType = fileType.toLowerCase()
      if (fileType !== 'png' && fileType !== 'jpg' && fileType !== 'jpeg' && fileType !== 'gif') {
        toast({msg: '只能上传图片文件'})
        return false
      }
      try {
        this.showRemarkModal.uploading = true
        const imgUrl = await uploadAbnormalImg({ image: file, orderCode: this.showRemarkModal.record.orderCode })
        this.showRemarkModal.fileList.push(imgUrl)
      } catch (error) {
        toast({ msg: error.message })
      } finally {
        this.showRemarkModal.uploading = false
      }
      return false
    },
    previewImage (item) {
      this.showRemarkModal.previewUrl = item
      this.showRemarkModal.imagePreview = true
    },
    deleteImage (index) {
      this.showRemarkModal.fileList.splice(index, 1) 
    },
    closeShowRemarkModal () {
      this.showRemarkModal.visible = false
      this.showRemarkModal.record = ''
      this.showRemarkModal.fileList = []
      this.showRemarkModal.remark = ''
    },
    async addRemarkAction () {
      try {
        this.showRemarkModal.saveLoading = true
        const params = {
          method: 'monitorService.uploadRemark',
          content: {
            id: this.showRemarkModal.record.id,
            remark: encodeURIComponent(this.showRemarkModal.remark || ''),
            remarkImg: this.showRemarkModal.fileList.join(',')
          }
        }
        await getMonitorData(params)
        toast({ msg: '保存成功', type: 'success', title: '操作提示' })
        this.closeShowRemarkModal()
        await this.getList()
      } catch (error) {
        toast({ msg: error.message })
      } finally {
        this.showRemarkModal.saveLoading = false
      }
    }
  }
}

</script>
<style lang="less">
@import url('../../style/index.less');
.monitorPage{
  margin: 10px 16px;
  display: flex;
  max-height: 100%;
  align-items: stretch;
  overflow-y: auto;
  .leftContent{
    flex: 1;
    overflow-y: auto;
    .searchTab{
      padding: 0 16px;
      background-color: @baseColor;
    }
    .divider{
      margin: 0 -16px;
      height: 10px;
      background-color: @pageBgColor;
    }
    .orderListWrap{
      margin: 0 -16px;
    }
    .page{
      margin: 16px 0;
    }
  }
  .rightContent{
    width: 400px;
    margin-left: 10px;
    overflow-y: auto;
    background-color: @baseColor;
    .rightContentWrap{
      padding: 16px;
    }
    .cellItem{
      display: flex;
      font-size: 16px;
      margin-bottom: 16px;
      align-items: center;
      .label{
        width: 120px;
        align-self: flex-start;
      }
      .labelVal{
        flex: 1;
        text-align: left;
        .imageItem{
          width: 80px;
          margin-right: 10px;
          margin-bottom: 10px;
          object-fit: cover;
          vertical-align: top;
          cursor: pointer;
        }
        .videoUrl{
          display: inline-block;
          background: @pageBgColor;
          padding: 10px;
          margin-right: 10px;
          margin-bottom: 10px;
          cursor: pointer;
          box-shadow: 0 2px 12px 0 #ebeef5;
          word-break: break-all;
        }
      }
    }
  }
}
.mateModal{
  .mateModalContent{
    display: flex;
    .leftContent{
      flex: 1;
      margin-right: 16px;
      .orderList{
        margin-top: 16px;
      }
    }
    .rightContent{
      border-left: 1px solid #ccc;
      padding-left: 16px;
      width: 300px;
    }
    .cellItem{
      display: flex;
      margin-bottom: 16px;
      align-items: center;
      .label{
        width: 100px;
        align-self: flex-start;
      }
      .labelVal{
        flex: 1;
        text-align: left;
        .imageItem{
          width: 80px;
          margin-right: 10px;
          margin-bottom: 10px;
          object-fit: cover;
          vertical-align: top;
          cursor: pointer;
        }
        .videoUrl{
          display: inline-block;
          background: @pageBgColor;
          padding: 10px;
          margin-right: 10px;
          margin-bottom: 10px;
          cursor: pointer;
          box-shadow: 0 2px 12px 0 #ebeef5;
          word-break: break-all;
        }
      }
    }
  }
  .modalSearch{
    display: flex;
    align-items: center;
  }
}
.showVideoModal{
  .ant-modal-body{
    max-height: 540px !important;
  }
  .video-player{
    .video-js{
      position: relative;
      width: 100%;
      overflow: hidden;
      .vjs-big-play-button{
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
.showRemarkModal{
  .uploadPanel{
    margin-top: 12px;
  }
  .uploadCard{
    display: table-cell;
    border: 1px solid #999;
    color: #999;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
    padding: 12px;
  }
   .imageList{
    margin-top: 12px;
    overflow: hidden;
    .imageItem{
      position:relative;
      width:104px;
      height:104px;
      float:left;
      margin: 0 8px 8px 0;
      border: 1px solid #d9d9d9;
      border-radius:4px;
      padding: 8px;
      img{
        width:86px;
        height:86px;
        object-fit:cover;
        position:relative;
        z-index:1;
      }
      .actionWrap{
        position:absolute;
        z-index:100;
        top:8px;
        left:8px;
        right:8px;
        bottom:8px;
        display:flex;
        align-items:center;
        justify-content: center;
        background-color:#333;
        color: #fff;
        opacity: 0.6;
      }
    }
  }
}
</style>